import { useNavigate } from "@usas/ui-web/wrappers/ReactRouterDom";

import useClubStaffData from "../../../../../../state/clubStaff/UseClubStaffData";

import useOrgRoleStaffRoleHierarchyData from "@usas/ui-web/state/orgRoleStaffRoleHierarchy/UseOrgRoleStaffRoleHierarchyData";
import useNavRoutes from "@usas/ui-web/state/security/UseNavRoutes";

const useClubStaffLoadingModal = () => {
  const navigate = useNavigate();
  const { resetClubStaffState } = useClubStaffData();
  const { clearOrgRolesStaffRolesHierarchyData } = useOrgRoleStaffRoleHierarchyData();
  const { navRoutes } = useNavRoutes();

  const onReloadClicked = (event) => {
    event?.preventDefault();

    const homeRoute = navRoutes.CLUB_STAFF?.route;

    if (homeRoute && homeRoute !== window.location.pathname) {
      resetClubStaffState();
      clearOrgRolesStaffRolesHierarchyData();

      navigate(homeRoute);
    } else {
      window.location.reload();
    }
  };

  const onBackToClubInfoClicked = (event) => {
    event?.preventDefault();

    resetClubStaffState();
    clearOrgRolesStaffRolesHierarchyData();

    navigate(navRoutes.CLUB_INFO?.route);
  };

  return {
    onReloadClicked,
    onBackToClubInfoClicked
  };
};

export default useClubStaffLoadingModal;